export const PLAYER_OPTIONS_BUTTON_CLICK = 'PLAYER_OPTIONS_BUTTON_CLICK';
export const PLAYER_OPTIONS_SHOW_GRID = 'PLAYER_OPTIONS_SHOW_GRID';
export const PLAYER_OPTIONS_HIDE_GRID = 'PLAYER_OPTIONS_HIDE_GRID';

export const PLAYER_MODALS_Z_INDEX_INCREASE = 'PLAYER_MODALS_Z_INDEX_INCREASE';
export const PLAYER_MODALS_Z_INDEX_DECREASE = 'PLAYER_MODALS_Z_INDEX_DECREASE';
export const PLAYER_TIME_SLIDER_VAL_CHANGE = 'PLAYER_TIME_SLIDER_VAL_CHANGE';
export const PLAYER_TIME_SLIDER_MAX_CHANGE = 'PLAYER_TIME_SLIDER_MAX_CHANGE';
export const PLAYER_LIVE_OPTIONS_SHOW_OPTIONS =
  'PLAYER_LIVE_OPTIONS_SHOW_OPTIONS';
export const PLAYER_LIVE_OPTIONS_HIDE_OPTIONS = 'PLAYER_OPTIONS_HIDE_OPTIONS';
export const PLAYER_OPTIONS_SHOW_EPG = 'PLAYER_OPTIONS_SHOW_EPG';
export const PLAYER_OPTIONS_HIDE_EPG = 'PLAYER_OPTIONS_HIDE_EPG';

export const PLAYER_LIVE_SHOW_LANGUAGE_OPTIONS =
  'PLAYER_LIVE_SHOW_LANGUAGE_OPTIONS';
export const PLAYER_LIVE_HIDE_LANGUAGE_OPTIONS =
  'PLAYER_LIVE_HIDE_LANGUAGE_OPTIONS';
export const SET_LIVE_AVAILABLE_LANGUAGES = 'SET_LIVE_AVAILABLE_LANGUAGES';
export const SET_LIVE_AVAILABLE_CAPTIONS = 'SET_LIVE_AVAILABLE_CAPTIONS';

export const SET_LIVE_CURRENT_AUDIO_LANGUAGE = 'SET_LIVE_CURRENT_AUDIO_LANGUAGE'
export const SET_LIVE_CURRENT_CAPTIONS_LANGUAGE = 'SET_LIVE_CURRENT_CAPTIONS_LANGUAGE'
export const SET_TARGET_AUDIO = 'SET_TARGET_AUDIO';
